import { 
    SET_NODES,
    SET_EDGES,
    UPDATE_NODES,
    UPDATE_EDGES,
    SET_NODE_MODAL,
    MODIFY_NODE,
    SET_IS_ON_CONNECTION,
    SET_WINDOWS_LIST,
    SET_VARIABLES_PAYLOAD,
    SET_VARIABLE_FIELDS,
    SET_FORMULA_FIELD_DATA,
    SET_RESOURCES_LIST,
    UPDATE_RESOURCES_LIST,
    SET_WINDOW_FIELDS,
    SET_LAYOUT_FIELDS,
    CLEAR_RESOURCES_LIST,
    UPDATE_NODE_MODAL,
    SET_ARRAY_OBJECT_FIELDS,
    SET_LOOKUP_DETAILS,
    UPDATE_LOOKUP_DETAILS,
    UPDATE_LOOKUP_DETAILS_MULTI,
    SET_INPUT_VARIABLES,
    SET_FORMULA_FIELD_DETAILS,
    SET_ACTION_ELEMENTS_DETAILS,
    SET_ACTION_API_DATA,
    CLEAR_ACTION_API_DATA,
    SET_ASSIGNMENT_ARRAY_FIELD_DETAILS,
    SET_DIRECTORY_FIELD_DETAILS
} from "../actionTypes/StepsFlowActionTypes";

//SET NODES
export const setNodesAction = (payload) => {
  return { 
    type: SET_NODES, 
    payload:payload
  };
};

//SET EDGES
export const setEdgesAction = (payload) => {
  return { 
    type: SET_EDGES, 
    payload:payload
  };
};

//UPDATE NODES
export const updateNodesAction = (item)=>{
  return {
    type:UPDATE_NODES,
    payload:item
  }
}
//UPDATE EDGES
export const updateEdgesAction = (item)=>{
  return {
    type:UPDATE_EDGES,
    payload:item
  }
}

export const nodeModalAction = (data,boll)=>{
  return{
    type:SET_NODE_MODAL,
    payload:{
      dataObj:data,
      isModalOpen:boll
    }
  }
}

export const setNodeModalAction = (data,bool)=>{
  return{
    type:SET_NODE_MODAL,
    payload:{
      dataObj:data,
      isModalOpen:bool
    }
  }
}
export const updateNodeModalAction  = (updateDataObj)=>{
  return{
    type:UPDATE_NODE_MODAL,
    payload:{
      updateDataObj:updateDataObj
    }
  }
}

export const modifyNodeAction = (data,id)=>{
  return{
    type:MODIFY_NODE,
    payload:{
      nodeData:data,
      nodeId:id
    }
  }
}
export const setWindowFieldsAction = (winId,winFields)=>{
  return{
    type:SET_WINDOW_FIELDS,
    payload:{
      winId:winId,
      winFields:winFields
    }
  }
}

export const setLayoutFieldsAction = (winId,laytFields)=>{
  return{
    type:SET_LAYOUT_FIELDS,
    payload:{
      winId:winId,
      laytFields:laytFields
    }
  }
}

export const setArrayObjectVariablesAction = (varId,fields)=>{
  return{
    type:SET_ARRAY_OBJECT_FIELDS,
    payload:{
      varId:varId,
      fields:fields
    }
  }
}



export const setStepsIsOnConnectionAction = (bool) =>{
  return{
    type:SET_IS_ON_CONNECTION,
    payload:{
      bool:bool
    }
  }
}

export const setWindowsListAction = (windowsList) =>{
  return{
    type:SET_WINDOWS_LIST,
    payload:windowsList
  }
}


export const setVariablesPayloadAction = (obj)=>{
  return {
    type:SET_VARIABLES_PAYLOAD,
    payload:obj
  }
}

export const setVariableFieldsAction = (obj) =>{
  return{
    type:SET_VARIABLE_FIELDS,
    payload:obj
  }
}



export const setFormulaFieldDataAction = (obj)=>{
  return {
    type:SET_FORMULA_FIELD_DATA,
    payload:obj
  }
}

export const setResourcesListAction = (payload) =>{
  return{
    type:SET_RESOURCES_LIST,
    payload:payload
  }
}
export const updateResourcesListAction = (key,val) =>{
  return{
    type:UPDATE_RESOURCES_LIST,
    payload:{
      resourceKey:key,
      resourceValue:val
    }
  }
}

export const clearResourcesListAction = ()=>{
  return{
    type:CLEAR_RESOURCES_LIST,
    payload:{}
  }
}


export const setLookupFieldDetails = (arrayObj,bool)=>{
  return{
    type:SET_LOOKUP_DETAILS,
    payload:{
      lookupFieldsData:arrayObj,
      bool:bool
    }
  }
}
export const setFormulaFieldDetails  = (fieldObj,bool)=>{
  return{
    type:SET_FORMULA_FIELD_DETAILS,
    payload:{
      fieldObj:fieldObj,
      bool:bool
    }
  }
}
export const updateLookupFieldDetails = (apiKey,valueObj)=>{
  return{
    type:UPDATE_LOOKUP_DETAILS,
    payload:{
      apiKey:apiKey,
      valueObj:valueObj
    }
  }
}

export const updateLookupFieldDetailsMulti = (sectionId,rowIndex,apiKey,valueObj)=>{
  return{
    type:UPDATE_LOOKUP_DETAILS_MULTI,
    payload:{
      sectionId:sectionId,
      subformRowIndex:rowIndex,
      apiKey:apiKey,
      valueObjMulti:valueObj
    }
  }
}

export const updateInputValuesPayloadAction = (payload)=>{
  return{
    type:SET_INPUT_VARIABLES,
    payload:payload
  }
}

export const setActionsElementsDetailsAction = (payload)=>{
  return{
    type:SET_ACTION_ELEMENTS_DETAILS,
    payload:payload
  }
}

export const setActionAPIDataAction = (apiKey,apiUrl,apiData,apiPayLoad={},lookupData,isArrayData=false,paramValue='',paramValueAll=null)=>{
  //console.log('setActionAPIDataAction==',paramValueAll)
  return{
    type:SET_ACTION_API_DATA,
    payload:{
      apiKey:apiKey,
      apiUrl:apiUrl,
      apiData:apiData,
      apiPayLoad:apiPayLoad,
      lookupData:lookupData,
      isArrayData:isArrayData,
      paramValue:paramValue,
      paramValueAll:paramValueAll
    }
  }
}

export const clearActionAPIDataAction = ()=>{
  return{
    type:CLEAR_ACTION_API_DATA,
  }
}

export const setAssignmentArrayFieldDetails  = (fieldObj,bool,curObj)=>{
  console.log(curObj);
  return{
    type:SET_ASSIGNMENT_ARRAY_FIELD_DETAILS,
    payload:{
      fieldObj:fieldObj,
      bool:bool,
      currentData:curObj
    }
  }
}

export const setDirectoryFieldDetails  = (fieldObj,bool)=>{
  //console.log('setDirectoryFieldDetails',bool,fieldObj)
  return{
    type:SET_DIRECTORY_FIELD_DETAILS,
    payload:{
      fieldObj:fieldObj,
      bool:bool
    }
  }
}
